import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import UITitle from '../../components/UI/UITitle'
import WidgetMakerHeader from '../../components/Widget/WidgetMakerHeader'
import { leToBr } from '../../utils/Utils'
import { StyleSheet, css } from 'aphrodite'
import Checkout from '../../components/Checkout/Checkout'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import config from '../../config'
import { toast } from 'react-toastify'
import api from '../../api'
import { MEDIA_MIN_SM } from '../../lib/breakpoints'

const stripePromise = loadStripe(config.REACT_APP_STRIPE_PB)

function Payments() {
  const { t } = useTranslation('translation')

  const [clientSecret, setClientSecret] = useState(null)
  const idRequest = localStorage.getItem('idRequest')

  useEffect(() => {
    ;(async () => {
      api
        .post(`${config.API_BASE_URL}/requests/${idRequest}/payments`)
        .then((data) => {
          setClientSecret(data.stripeClientSecret)
          localStorage.setItem('clientSecret', data.stripeClientSecret)
        })
        .catch((error) => {
          toast.error(t('pages.payments.unexpectedError'))
          console.log('error get paymentIntent : ', error)
        })
    })()
  }, [])

  return (
    <>
      <WidgetMakerHeader
        handleBecomeMakerClick={() => {}}
        handleGlobeClick={function noRefCheck() {}}
      />
      <div className={css(styles.container)}>
        <div>
          <UITitle
            label={t('pages.payments.title')}
            dynamicStyle={styles.title}
          />
          <p className={css(styles.instruction)}>
            {leToBr(t('pages.payments.instruction1'))}
            <span className={css(styles.emphasize)}>
              {t('pages.payments.instruction2')}
            </span>
            {t('pages.payments.instruction3')}
          </p>
          {clientSecret ? (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <Checkout />
            </Elements>
          ) : (
            <span>Chargement...</span>
          )}
        </div>
      </div>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: 24,
  },
  title: {
    fontFamily: 'Helvetica',
    fontSize: 24,
    margin: 0,
    [MEDIA_MIN_SM]: {
      fontSize: 32,
    },
  },
  instruction: {
    fontFamily: 'Helvetica',
    fontSize: 12,
    [MEDIA_MIN_SM]: {
      fontSize: 14,
    },
  },
  emphasize: {
    fontWeight: 'bold',
    textDecoration: 'underline',
  },
})

export default Payments
